import axios from "axios";

const apiClient = axios.create();

let handoffToken: string | null = null;

export const setHandoffToken = (token: string | null) => {
  handoffToken = token;
};

export const getHandoffToken = () => handoffToken;

const getBaseUrl = () => {
  const serverUrl = process.env.REACT_APP_SERVER_URL?.replace(/\/$/, "");
  return serverUrl ? `${serverUrl}/api/v1/kyc-mobile` : "/api/v1/kyc-mobile";
};

apiClient.interceptors.request.use((config) => {
  if (handoffToken) {
    config.headers.Authorization = `Bearer ${handoffToken}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handoffToken = null;
    }
    return Promise.reject(error);
  }
);

export const openSession = async (sessionId: string) => {
  const response = await apiClient.get(
    `${getBaseUrl()}/sessions/${sessionId}/open`
  );
  return response.data;
};

export const uploadDocument = async (
  sessionId: string,
  file: File,
  side: "front" | "back"
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("side", side);
  const response = await apiClient.post(
    `${getBaseUrl()}/sessions/${sessionId}/documents`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

export const submitSession = async (sessionId: string) => {
  const response = await apiClient.post(
    `${getBaseUrl()}/sessions/${sessionId}/submit`
  );
  return response.data;
};

export const getSessionStatus = async (sessionId: string) => {
  const response = await apiClient.get(
    `${getBaseUrl()}/sessions/${sessionId}/status`
  );
  return response.data;
};

export const cancelSession = async (sessionId: string) => {
  const response = await apiClient.delete(
    `${getBaseUrl()}/sessions/${sessionId}`
  );
  return response.data;
};
